import React, { Fragment, useEffect, useState } from 'react'
import axiosInstance from "../../../../../AxiosInstance";
import {FileInput, TextInput} from "../../../../../components/input/inputs";
import {Select} from "../../../../../components/ajonjolib/inputs/ajonjolinput";
import Modal from "../../../../../components/modal/modal";
import {toast} from "../../../../../components/toasts/toast/toast";

function appendUserFormData(formData, form) {
    for (const key in form) {
        if (form[key] === undefined || form[key] === "") continue;
        const value = key === 'username' ? String(form[key]).toLowerCase() : form[key];
        formData.append(key, value);
    }
}

export default function CreateUserModal({show, setter, editing, form, setForm, reload, roles}) {
    const create = async () => {
        let formData = new FormData();
        appendUserFormData(formData, form);

        const response = await axiosInstance.post('register/', formData);
        reload();
        toast("Usuario creado");
        setter(false);
    }

    const update = async () => {
        console.log(form);
        let formData = new FormData();
        appendUserFormData(formData, form);

        const response = await axiosInstance.put('user/' + form.id + '/', formData);
        reload();
        toast("Usuario actualizado");
        setter(false);
    }

    return (
        <Modal size={'xl'} show={show} setter={setter} name={`${editing ? "Editar" : "Agregar"} Usuario`}
               buttonName={'Guardar'} onClick={() => {
            if((form.password !== "" && form.password_2 !== "") || (form.password !== undefined && form.password_2 !== undefined)) {
                if (form.password !== form.password_2) {
                    alert('Las contraseñas no coinciden');
                    return;
                }
            }
            if (editing) update();
            else create();
        }}>
            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '35%'
                }}>
                    <TextInput grey={true} name={'Nombres'} internalName={'first_name'} form={form} setForm={setForm}/>
                </div>
                <div style={{
                    flexBasis: '35%'
                }}>
                    <TextInput grey={true} name={'Apellidos'} internalName={'last_name'} form={form} setForm={setForm}/>
                </div>

                <div style={{
                    flexBasis: '20%'
                }}>
                    <TextInput grey={true} name={'DNI'} internalName={'dni'} form={form} setForm={setForm}
                               type={'number'}/>
                </div>
            </div>

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '65%'
                }}>
                    <TextInput grey={true} name={'Dirección'} internalName={'address'} form={form} setForm={setForm}/>
                </div>

                <div style={{
                    flexBasis: '30%'
                }}>
                    <TextInput grey={true} name={'Teléfono'} internalName={'phone'} form={form} setForm={setForm}
                               type={'number'}/>
                </div>
            </div>

            <div className={'d-flex justify-content-between mb-3'}>
                <div style={{
                    flexBasis: '31%'
                }}>
                    <div>Tipo de Usuario</div>
                    <Select value={form['is_staff']}
                            options={[{value: 0, name: "Proveedor"}, {value: 1, name: "Cliente"}]}
                            onChange={(value) => {
                                const v = value[0];
                                setForm({
                                    ...form,
                                    is_staff: v,
                                    can_final_approve_invoice: v === 1 ? (form.can_final_approve_invoice ?? 0) : 0,
                                    can_pre_approve_invoice: v === 1 ? (form.can_pre_approve_invoice ?? 0) : 0,
                                });
                            }}/>
                </div>

                {form['is_staff'] ?
                    <div style={{
                        flexBasis: '31%'
                    }}>
                        <div>Perfil de Usuario</div>
                        <Select value={form['role']} options={roles?.map((x) => {
                            return {name: x.name, value: x.id}
                        })} onChange={(value) => {
                            setForm({...form, role: value[0]})
                        }}/>
                    </div>
                    :
                    <div style={{
                        flexBasis: '31%'
                    }}>
                        <div>Perfil de Usuario</div>
                        <Select value={form['role']} options={roles?.map((x) => {
                            return {name: x.name, value: x.id}
                        })} onChange={(value) => {
                            setForm({...form, role: value[0]})
                        }}/>
                    </div>
                }

                <div style={{
                    flexBasis: '31%'
                }}>
                    <div>Estado</div>
                    <Select value={form['is_active']}
                            options={[{value: 0, name: "Inactivo"}, {value: 1, name: "Activo"}]} onChange={(value) => {
                        setForm({...form, is_active: value[0]})
                    }}/>
                </div>
            </div>

            {form['is_staff'] === 1 ? (
                <div className={'d-flex justify-content-between mb-3'}>
                    <div style={{ flexBasis: '31%' }}>
                        <div>Puede pre-aprobar facturas</div>
                        <Select
                            value={form['can_pre_approve_invoice']}
                            options={[
                                { value: 0, name: 'No' },
                                { value: 1, name: 'Sí' },
                            ]}
                            onChange={(value) => {
                                setForm({ ...form, can_pre_approve_invoice: value[0] });
                            }}
                        />
                    </div>
                    <div style={{ flexBasis: '31%' }}>
                        <div>Puede aprobar facturas (definitivo)</div>
                        <Select
                            value={form['can_final_approve_invoice']}
                            options={[
                                { value: 0, name: 'No' },
                                { value: 1, name: 'Sí' },
                            ]}
                            onChange={(value) => {
                                setForm({ ...form, can_final_approve_invoice: value[0] });
                            }}
                        />
                    </div>
                </div>
            ) : null}

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'R.U.C. - Razón Social'} internalName={'ruc'} form={form}
                               setForm={setForm}/>
                </div>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Correo Electrónico'} internalName={'username'} form={form}
                               setForm={setForm}/>
                </div>
            </div>

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} type={'password'} name={'Contraseña'} internalName={'password'} form={form}
                               setForm={setForm}/>
                </div>

                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} type={'password'} name={'Confirmar Contraseña'} internalName={'password_2'}
                               form={form} setForm={setForm}/>
                </div>
            </div>
        </Modal>
    )
}